import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=58e4f478&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports